
export function biblicalBoooksAndCategories() {
    const categories = [
        {id: 'old-testament', name: 'Ancien Testament'},
        {id: 'new-testament', name: 'Nouveau Testament'},
        {id: 'prophets', name: 'Prophètes'},
        {id: 'gospels', name: 'Évangiles'},
        {id: 'paul-letters', name: 'Épîtres de Paul'},
        {id: 'history', name: 'Histoire biblique'},
        {id: 'characters', name: 'Personnages bibliques'},
        {id: 'psalms', name: 'Psaumes'},
        {id: 'proverbs', name: 'Proverbes'},
        {id: 'parables', name: 'Paraboles'}
    ];

    const biblicalBooks = [
        // Ancien Testament
        {id: 'genesis', name: 'Genèse', testament: 'old'},
        {id: 'exodus', name: 'Exode', testament: 'old'},
        {id: 'leviticus', name: 'Lévitique', testament: 'old'},
        {id: 'numbers', name: 'Nombres', testament: 'old'},
        {id: 'deuteronomy', name: 'Deutéronome', testament: 'old'},
        {id: 'joshua', name: 'Josué', testament: 'old'},
        {id: 'judges', name: 'Juges', testament: 'old'},
        {id: 'ruth', name: 'Ruth', testament: 'old'},
        {id: '1samuel', name: '1 Samuel', testament: 'old'},
        {id: '2samuel', name: '2 Samuel', testament: 'old'},
        {id: '1kings', name: '1 Rois', testament: 'old'},
        {id: '2kings', name: '2 Rois', testament: 'old'},
        {id: '1chronicles', name: '1 Chroniques', testament: 'old'},
        {id: '2chronicles', name: '2 Chroniques', testament: 'old'},
        {id: 'ezra', name: 'Esdras', testament: 'old'},
        {id: 'nehemiah', name: 'Néhémie', testament: 'old'},
        {id: 'esther', name: 'Esther', testament: 'old'},
        {id: 'job', name: 'Job', testament: 'old'},
        {id: 'psalms', name: 'Psaumes', testament: 'old'},
        {id: 'proverbs', name: 'Proverbes', testament: 'old'},
        {id: 'ecclesiastes', name: 'Ecclésiaste', testament: 'old'},
        {id: 'songofsolomon', name: 'Cantique des Cantiques', testament: 'old'},
        {id: 'isaiah', name: 'Ésaïe', testament: 'old'},
        {id: 'jeremiah', name: 'Jérémie', testament: 'old'},
        {id: 'lamentations', name: 'Lamentations', testament: 'old'},
        {id: 'ezekiel', name: 'Ézéchiel', testament: 'old'},
        {id: 'daniel', name: 'Daniel', testament: 'old'},
        {id: 'hosea', name: 'Osée', testament: 'old'},
        {id: 'joel', name: 'Joël', testament: 'old'},
        {id: 'amos', name: 'Amos', testament: 'old'},
        {id: 'obadiah', name: 'Abdias', testament: 'old'},
        {id: 'jonah', name: 'Jonas', testament: 'old'},
        {id: 'micah', name: 'Michée', testament: 'old'},
        {id: 'nahum', name: 'Nahum', testament: 'old'},
        {id: 'habakkuk', name: 'Habacuc', testament: 'old'},
        {id: 'zephaniah', name: 'Sophonie', testament: 'old'},
        {id: 'haggai', name: 'Aggée', testament: 'old'},
        {id: 'zechariah', name: 'Zacharie', testament: 'old'},
        {id: 'malachi', name: 'Malachie', testament: 'old'},

        // Nouveau Testament
        {id: 'matthew', name: 'Matthieu', testament: 'new'},
        {id: 'mark', name: 'Marc', testament: 'new'},
        {id: 'luke', name: 'Luc', testament: 'new'},
        {id: 'john', name: 'Jean', testament: 'new'},
        {id: 'acts', name: 'Actes', testament: 'new'},
        {id: 'romans', name: 'Romains', testament: 'new'},
        {id: '1corinthians', name: '1 Corinthiens', testament: 'new'},
        {id: '2corinthians', name: '2 Corinthiens', testament: 'new'},
        {id: 'galatians', name: 'Galates', testament: 'new'},
        {id: 'ephesians', name: 'Éphésiens', testament: 'new'},
        {id: 'philippians', name: 'Philippiens', testament: 'new'},
        {id: 'colossians', name: 'Colossiens', testament: 'new'},
        {id: '1thessalonians', name: '1 Thessaloniciens', testament: 'new'},
        {id: '2thessalonians', name: '2 Thessaloniciens', testament: 'new'},
        {id: '1timothy', name: '1 Timothée', testament: 'new'},
        {id: '2timothy', name: '2 Timothée', testament: 'new'},
        {id: 'titus', name: 'Tite', testament: 'new'},
        {id: 'philemon', name: 'Philémon', testament: 'new'},
        {id: 'hebrews', name: 'Hébreux', testament: 'new'},
        {id: 'james', name: 'Jacques', testament: 'new'},
        {id: '1peter', name: '1 Pierre', testament: 'new'},
        {id: '2peter', name: '2 Pierre', testament: 'new'},
        {id: '1john', name: '1 Jean', testament: 'new'},
        {id: '2john', name: '2 Jean', testament: 'new'},
        {id: '3john', name: '3 Jean', testament: 'new'},
        {id: 'jude', name: 'Jude', testament: 'new'},
        {id: 'revelation', name: 'Apocalypse', testament: 'new'}
    ];
    return {categories, biblicalBooks};
}
